module.exports = __webpack_public_path__ + "static/media/Twin Tower 1.4b842134.png";